export default {
   messages_templates_tab_id: 'Id',
   messages_templates_template: 'Plantilla',
   messages_templates_language: 'Idioma',
   messages_templates_email_from: 'Correo electrónico de',
   messages_templates_email_body: 'Cuerpo del correo electrónico',
   messages_templates_add_message_template: 'Agregar plantilla de mensaje',
   messages_templates_edit: 'Editar',
   messages_templates_tab_templates_title: 'Plantillas de mensajes',
   messages_templates_email_subject: 'Asunto del correo electrónico',
   messages_templates_delete: 'Eliminar',
   messages_templates_name: 'Nombre',
   messages_templates_username: 'Nombre de usuario',
   messages_templates_link: 'Enlace',
   messages_templates_code: 'Código',
   messages_templates_template_fields: 'Campos de plantilla',


   messages_templates_tab_name: 'Nombre',
   messages_templates_tab_brand: 'Marca',
   messages_templates_tab_status: 'Estado',
   messages_templates_tab_companies: 'Compañias',
   messages_templates_tab_accounts: 'Cuentas',
   messages_templates_tab_advanced_filters: 'Filtros avanzados',
   messages_templates_tab_apply: 'Aplicar',
   messages_templates_tab_tags: 'Etiquetas',
   messages_templates_tab_active_accounts_only: 'Sólo cuentas activas',
   messages_templates_tab_yes: 'Si',
   messages_templates_tab_no: 'No',
   messages_templates_tab_authenticate_cloud: 'Iniciar sesión como cliente',
   messages_templates_tab_re_sync_backend_information: 'Re-sincronización de la información del backend',
   messages_templates_tab_devices: 'Dispositivos',
   messages_templates_tab_package: 'Paquete',
   messages_templates_tab_crm: 'Id. de Salesforce',
   messages_templates_tab_add_account: 'Agregar cuenta',
   messages_templates_tab_edit: 'Editar',
   messages_templates_tab_remove_filters: 'Eliminar los filtros',
   messages_templates_tab_account_details: 'Detalles de la cuenta',
   messages_templates_tab_import_from_p4: 'Importar desde P4',
   messages_templates_tab_reprocess_odo_hours: 'Reprocesar Odo/Hrs',
   messages_templates_tab_new_status: 'Nuevo Estado',
   messages_templates_tab_at: 'el',
   messages_templates_tab_next_scheduled_action: 'Próxima acción programada',
   messages_templates_tab_on: 'en'
};